module.exports = __webpack_public_path__ + "static/img/C (12).d4557037.png";